export enum AddressTypeEnum {
  Office = 1,
  Home = 2,
  Other = 4,
  Billing = 5
}
